import Cookies from 'js-cookie';
import { captureException } from '@sentry/react';
import { getErrorMessage } from '@beef/shop-common';

import { getProductId } from 'store/ProductDetails/selectors';
import { cartApi } from 'api';
import { addProductToBasket } from 'store/common/basket/actions';
import { getCurrentRegionCode } from 'store/common/settings/selectors';
import { getIsItemInBasket } from 'store/common/basket/selectors';
import { PLACEMENTS } from 'store/common/recommendations/constants';
import { RecommendedDevice, RecommendationBlockData } from 'store/common/recommendations/types';

export const fetchRecommendedDevices =
  (placementProp: PLACEMENTS) =>
  // eslint-disable-next-line consistent-return
  async (dispatch, getState): Promise<RecommendationBlockData | undefined> => {
    const state = getState();
    const productId = getProductId(state);
    const regionCode = getCurrentRegionCode(state);
    const digiUc = Cookies.get('digi_uc') || '';

    try {
      const { strategyName = '', placements = [] } = await cartApi.digineticaGetRecommends({
        product_id: productId,
        region_id: regionCode,
        placement: placementProp,
        digi_uc: digiUc,
      });

      if (placements.length) {
        const { items = [], placement = '', strategyMessage = '' } = placements[0];
        const devices: RecommendedDevice[] = cartApi.helpers.createRecommendedDevices(items);

        // eslint-disable-next-line consistent-return
        return {
          strategyName,
          strategyMessage,
          placement,
          devices,
        };
      }
    } catch (error) {
      captureException(error);
      const errorMessage = getErrorMessage(error);
      throw new Error(errorMessage);
    }
  };

export const addRecommendedDeviceToBasket =
  (deviceId: number, source: string) => async (dispatch, getState) => {
    const state = getState();
    const isInBasket = getIsItemInBasket(state, deviceId);

    dispatch(
      addProductToBasket({
        productId: deviceId,
        source,
        isInBasket,
        forceRedirect: true,
      }),
    );
  };
